import styled from 'styled-components';

const StyledContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export { StyledContainer };
